import React, { useState, useRef } from 'react';

interface RequiredAsteriskTooltipProps {
  delay?: number; // milisegundos para mostrar el tooltip (default 800ms)
}

const RequiredAsteriskTooltip: React.FC<RequiredAsteriskTooltipProps> = ({ delay = 800 }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const handleMouseEnter = () => {
    timerRef.current = setTimeout(() => {
      setShowTooltip(true);
    }, delay);
  };

  const handleMouseLeave = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    setShowTooltip(false);
  };

  return (
    <div
      className="group relative inline-block"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <span className="cursor-help text-meta-1">*</span>
      {showTooltip && (
        <div className="absolute bottom-full left-1/2 z-20 mb-2 -translate-x-1/2 whitespace-nowrap rounded bg-black px-3 py-1 text-xs font-medium text-white">
          <span className="absolute bottom-[-4px] left-1/2 -z-10 h-2 w-2 -translate-x-1/2 rotate-45 bg-black" />
          Este campo es obligatorio
        </div>
      )}
    </div>
  );
};

export default RequiredAsteriskTooltip;
